<template>
  <v-app style="background:#ffffff;">

    <v-content>
      <router-view></router-view>
      <v-card height="1000px" elevation="0">
        <v-bottom-navigation
                v-model="bottomNav"
                grow
                color="teal"
                horizontal
                fixed
        >

          <router-link to="/todos" tag="p">
            <v-btn value="actiepunten">
              <span>Actiepunten</span>
              <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
          </router-link>

          <router-link to="/history" tag="p">
            <v-btn value="tijdlijn">
              <span>Tijdlijn</span>
              <v-icon>mdi-history</v-icon>
            </v-btn>
          </router-link>

        </v-bottom-navigation>
      </v-card>


    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    //
  }),
};
</script>


